export default "__VITE_ASSET__nG3TGQNc__"